import React from 'react';
import { usePrefixTranslation } from '../../../i18n';
import { actions, useTypedDispatch, useTypedSelector } from '../../../redux';
import { Filter } from '../../../redux/project/list';
import { enumToIcon, enumToStatusType } from '../../../types/common';
import { StatusIconsCard } from '../cards/StatusIconsCard';

/**
 * Fetch project status counts information and render it using a status icons card.
 */
export const StatusCounts = () => {
    const { t } = usePrefixTranslation('common');
    const dispatch = useTypedDispatch();
    const { statusCounts } = useTypedSelector(state => ({ statusCounts: state.stats.statusCounts }));

    React.useEffect(() => void dispatch(actions.stats.statusCounts()), []);

    const data = ['past due', 'ready to inspect', 'in progress', 'awaiting report', 'under review', 'completed'].map(
        name => ({
            name: t(`status.${name}`),
            value: statusCounts.stats?.[name] ?? 0,
            type: enumToStatusType[name],
            icon: enumToIcon[name],
            onClick: () => dispatch(actions.project_list.list({ filter: name as Filter })),
            href: '/projects',
        }),
    );

    return <StatusIconsCard fetching={statusCounts.fetching} data={data} />;
};
